import React from 'react';
import { View } from 'react-native';

import { useThemedStyles } from '../../hooks/useThemedStyles';
import { Tag } from '../../design/components';

import { createPickListDetailStyles } from './PickListDetail.styles';

// Tub, cash bag and packing tags of the pick list's docket (nothing when none apply).
const PickListDocketTags = ({ serviceDocket, enableTubsFieldOnDockets, packTags }) => {
	const styles = useThemedStyles(createPickListDetailStyles);

	if (!(
		(enableTubsFieldOnDockets && Boolean(serviceDocket && serviceDocket.tub)) ||
		Boolean(serviceDocket && serviceDocket.cashBag) ||
		Boolean(packTags.length)
	)) {
		return null;
	}

	return (
		<View style={styles.tags}>
			{
				enableTubsFieldOnDockets && Boolean(serviceDocket && serviceDocket.tub) && (
					<Tag size="regular" label={`Tub: ${serviceDocket.tub}`} />
				)
			}
			{
				Boolean(serviceDocket && serviceDocket.cashBag) && (
					<Tag size="regular" label={`Cash bag: ${serviceDocket.cashBag}`} />
				)
			}
			{
				packTags.map(tag => (
					<Tag key={tag.id} size="regular" tone="warning" label={tag.name} />
				))
			}
		</View>
	);
};

export default PickListDocketTags;
